/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-10-23T09:57:30.916
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listHrProjectParams,
	listHrProjectParamsInit,
	listHrProjectParamsByAuthorizations,
	deleteHrProjectParams
	
} from '@api/rentmanage/HrProjectParams';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listHrProjectParams({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHrProjectParams(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHrProjectParamsByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHrProjectParamsByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHrProjectParamsInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHrProjectParamsInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteHrProjectParams({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteHrProjectParams({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
